export enum GanttRoute {
  GANTT = '/planner',
}
